import { Vue } from '../types'

export const isVue3 = (Vue: { version: string }) => {
  return Vue.version.startsWith('3')
}

export const loadVue = (): Vue => {
  try {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const importedModule = require('vue')
    // @ts-ignore
    return importedModule.default || importedModule
  } catch (e) {
    throw Error('Vue is not found. Pls install Vue first')
  }
}
